import React, { useMemo } from "react";
import { Card, Spinner, Table } from "../../../shared";
import { renderAmount } from "../../../utils";

const currencyKeys = new Set(["total", "totalCharges", "calculatedTotalCharges"]);

const TableWidget = ({ widget, loading }) => {
  const payload = widget?.data || {};
  const rows = Array.isArray(payload.rows) ? payload.rows : [];
  const columns = useMemo(() => {
    const sourceColumns = Array.isArray(payload.columns) ? payload.columns : [];
    return sourceColumns.map((column) => ({
      accessorKey: column.key,
      header: column.label,
      cell: ({ getValue }) => {
        const value = getValue();
        if (currencyKeys.has(column.key)) return renderAmount(value);
        return value || "-";
      },
    }));
  }, [payload.columns]);

  return (
    <Card className="h-full min-h-[360px] rounded-lg">
      <div className="mb-3 text-xs md:text-sm uppercase text-gray-500 font-bold">
        {widget?.title}
      </div>
      {loading ? (
        <div className="h-[250px] flex items-center justify-center">
          <Spinner size="lg" />
        </div>
      ) : !rows.length ? (
        <div className="h-[250px] flex items-center justify-center text-sm text-gray-500">
          No data to display for this time range.
        </div>
      ) : (
        <Table
          data={rows}
          columns={columns}
          hideCheckbox
          pageSize={8}
          enableSorting
        />
      )}
    </Card>
  );
};

export default TableWidget;
